/**
 * RankedEvents — match-end RP recap and ranked join rejection.
 *
 * rankedResult is targeted at the player whose RP just changed.
 * joinRejected is the whole client-visible outcome of the ranked guest gate.
 */

const RankedEvents = {
  /**
   * @param {Socket} socket
   * @param {GameState} _gameState
   * @param {Object} callbacks
   * @param {Function} [callbacks.notifySuccess]
   * @param {Function} [callbacks.notifyError]
   * @param {Function} [callbacks.applyRankedResult]
   */
  register(socket, _gameState, callbacks) {
    const {
      notifySuccess = () => {},
      notifyError = () => {},
      applyRankedResult = () => {}
    } = callbacks;

    socket.on('rankedResult', (data) => {
      if (!data || typeof data !== 'object') return;
      applyRankedResult(data);
      if (data.promoted === true && data.tierName) {
        notifySuccess(`Promoted to ${data.tierName}!`);
      }
    });

    socket.on('joinRejected', (data) => {
      const reason = data && data.reason;
      if (reason === 'ranked_requires_account') {
        notifyError('Sign in to play ranked');
        return;
      }
      notifyError("Can't join that mode");
    });
  }
};

export { RankedEvents };
